
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M20.929 13.131A9 9 0 1011.998 21M3.6 9h16.8M3.6 15h9.9"}}),_c('path',{attrs:{"d":"M11.5 3a17 17 0 000 18m1-18a16.992 16.992 0 012.505 10.573M22 22l-5-5m0 5l5-5"}})])])
          )
        }
      }
    